import DetailAccentCard from "../detail/DetailAccentCard";
import EditorFormActions from "./EditorFormActions";

export default function EditorFormShell({
	title,
	subtitle,
	children,
	errorMessage,
	onSubmit,
	submitLabel = "ذخیره",
	isLoading = false,
	secondaryAction,
}) {
	return (
		<DetailAccentCard bodyClassName="p-5 md:p-8" ariaLabel={title}>
			<h1 className="text-center font-Vazir-800 text-[20px] leading-snug text-darkBlue md:text-[22px]">
				{title}
			</h1>
			{subtitle && (
				<p className="mt-2 text-center font-Vazir-400 text-[14px] leading-relaxed text-darkBlue/60">
					{subtitle}
				</p>
			)}
			<div className="mt-6 flex flex-col gap-5">{children}</div>
			{errorMessage && (
				<p
					className="mt-5 rounded-[12px] border border-red-200 bg-red-50 px-4 py-3 text-center font-Vazir-400 text-[14px] text-[#cc0000]"
					role="alert"
				>
					{errorMessage}
				</p>
			)}
			{onSubmit && (
				<EditorFormActions
					onSubmit={onSubmit}
					isLoading={isLoading}
					submitLabel={submitLabel}
					secondaryAction={secondaryAction}
				/>
			)}
		</DetailAccentCard>
	);
}
